import axios from "axios";
import {METHOD_TYPE} from "@/common/utils/constants";
import {GRAPHQL_ENDPOINT} from "@/drc/services/drc-request-service";
const URL = process.env.VUE_APP_BACKEND_API_URL;
const VERSION = process.env.VUE_APP_BACKEND_API_URL_VERSION;

export function setGopCountry(countryId){
	return axios.patch(`${URL}/users/set-gop-country?countryId=${countryId}`);
}

export function getLandingPageBackgroundImage() {
	return axios.get(`${URL}/main/images/landing-page/get-current-background-image`);
}

export function getPublishedProjectsId(userId) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
    			getPublishedProjectsId(
							ownerId: ${userId}
					) {
       		 projectId
    			}
				}`
		}
	})
		.then(response => {
			return response.data.data.getPublishedProjectsId
		});
}

export function getUserProjectIdsWaitingForApproval(userId) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
    			getAwaitingForApprovalProjects(
							ownerId: ${userId}
					) {
       		 id
    			}
				}`
		}
	})
		.then(response => {
			return response.data.data.getAwaitingForApprovalProjects
		});
}

export function setUser(user, action) {
	return axios.patch(`${URL}/auth/public?action=${action}`, user);
}

export function manageUser(user, action) {
	return axios.patch(`${URL}/users/management?action=${action}`, user);
}

export function login(user, action) {
	return axios.post(`${URL}/auth/public?action=${action}`, user)
}

export function forgotPassword(username) {
	return axios.get(`${URL}/auth/public/${username}`)
}

export function validateJWT(jwt) {
	return axios.get(`${URL}/auth/public?jwt=${jwt}`);
}

export function getToolsAndSystems() {
	return axios.get(`${URL}/${VERSION}/main/filters/tools`);
}

export function getCertificates() {
	return axios.get(`${URL}/${VERSION}/main/filters/certifications`);
}

export function createQualificationAttributes(attributes) {
	return axios.post(`${URL}/gop/qualification-attributes`, attributes);
}


/**
 * @param requestBody: Example of the request body content:
 * {
 *   "from": <String>,	(the user email). It is not required/mandatory field.
 *   "to": <Receiver>,	(the field "to" cannot be null or empty object)
 *   "cc": <Receiver>,	(not mandatory field - can be null)
 *   "bcc": <Receiver>,	(not mandatory field - can be null)
 *   "title": <String>,	(the title of the email- The field 'title' cannot be null or empty.)
 *   "message": <String>,	(the field 'message' cannot be null or empty. Works with String that contains HTML)
 *   "showSender": <Boolean> (not mandatory field, by default is TRUE. Indicates whether to show the "from" email in the email message)
 * }
 *
 * Receiver: {
 * 		"userIds": [<Number>],             (represents some user ids)
 * 		"emails": [<String>],              (represents some user emails)
 * 		"userGroups" [<PermissionEnum>]		 (represents user permission Groups, like AdditionalCmtAccess)
 *   }
 *   - you can use even only one of the field to send an email. You also can combine two or three of the fields in a combination.
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
export function sendEmail(requestBody) {
	return axios.post(`${URL}/emails`, requestBody);
}

export function uploadEmailAttachment(requestBody) {
	return axios.post(`${URL}/main/images/report-a-problem`, requestBody);
}

export function getUserLatestSearches(){
	return axios.get(`${URL}/gop/analytics/recent-searches`);
}

export function getTrends(){
	return axios.get(`${URL}/gop/analytics/trends`);
}

export function getProjectReference(id){
	return axios.get(`${URL}/new-project/reference/${id}`);
}

export function minorSearchOffers(text){
	let body = {
		"text": text,
		"pageable": {
			"page": 0,
			"size": 2
		}
	}
	return axios.post(`${URL}/gop/main/offers/search-offer`, body);
}

export function minorSearchSectors(text){
	let body = {
		"text": text,
		"pageable": {
			"page": 0,
			"size": 2
		}
	}
	return axios.post(`${URL}/gop/main/sector-presentations/search-sector`, body);
}

export function searchProductsOffers(){
	let body = {
		"contentLanguageId": 1,
		"serviceLines": [12],
		"types": ["GLOBAL"],
		"pageable": {
			"page": 0,
			"size": 100
		}
	}
	return axios.post(`${URL}/gop/main/offers/search-offer`, body);
}

export function searchProductsSectors(){
	let body = {
		"contentLanguageId": 1,
		"serviceLines": [12],
		"types": ["GLOBAL"],
		"pageable": {
			"page": 0,
			"size": 100
		}
	}
	return axios.post(`${URL}/gop/main/sector-presentations/search-sector`, body);
}
